import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { fmtErr } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(fmtErr(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cast px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-sm border border-brass/15 bg-card p-10" data-testid="admin-login-form">
        <p className="text-xs uppercase font-mono tracking-[0.3em] text-brass">CMS</p>
        <h1 className="mt-2 font-serif text-3xl font-bold text-cream">Kitchen Entrance</h1>
        <label className="admin-label mt-8">Email</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="admin-input" data-testid="admin-email-input" />
        <label className="admin-label mt-5">Password</label>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="admin-input" data-testid="admin-password-input" />
        {error && <p className="mt-4 text-sm text-flame" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit" className="mt-8 w-full rounded-full bg-brass py-3 text-sm font-semibold uppercase tracking-widest text-cast transition-colors hover:bg-flame hover:text-cream disabled:opacity-50">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
